import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { CardTitle, Tooltip } from 'reactstrap';

const TOOLTIP_TEXTS = {
    PICKUP: {
        title: 'Start Here: Pickup Info',
        description: (
            <>
                Your Gophr account details are the default information. Change the contact info and select a different address if you are the receiver. Include any special{' '}
                <b>Pickup Instructions</b> to help your driver out!
            </>
        )
    },
    DROPOFF: {
        title: 'Finish Strong: Dropoff Info',
        description: (
            <>
                Provide the receiver’s contact information and delivery address. Your past delivery data is saved securely and can be autofilled for your convenience.{' '}
                <b>Dropoff Instructions</b> are helpful to ensure a smooth delivery!
            </>
        )
    },
    DETAILS: {
        title: 'Item Details: What are you shipping?',
        description: (
            <>
                <div style={{ color: '#344675', marginBottom: 2 }}>
                    <b>Order ID:</b> For your reference, add an internal PO or company ticket number
                </div>
                <div style={{ color: '#344675', marginBottom: 2 }}>
                    <b>Description:</b> Add the common item name (specific part, piece of equipment, etc.)
                </div>
                <div style={{ color: '#344675', marginBottom: 2 }}>
                    <b>Quantity & Unit:</b> Enter how many items and how it's packaged (item, crate, pallet, etc.)
                </div>
                <div style={{ color: '#344675', marginBottom: 2 }}>
                    <b>Expand for more:</b> Click the arrow to enter the approximate item dimensions and weight
                </div>
                <div style={{ color: '#344675', marginBottom: 2 }}>
                    <b>AI Assist:</b> Gophr will calculate the estimated weight, dimensions and optimal vehicle type
                </div>
                <div style={{ color: '#344675', marginBottom: 2 }}>
                    <b>NMFC:</b> Only required for palletized LTL shipments
                </div>
            </>
        )
    }
};

const tooltipBoxStyle = {
    background: '#fff',
    color: '#222',
    borderRadius: 8,
    padding: '16px 18px',
    fontSize: 13,
    lineHeight: 1.6,
    minWidth: 680,
    width: 680,
    maxWidth: 680,
    border: '1.5px solid #b5d2ee',
    textAlign: 'left',
    boxShadow: 'none'
};

const tooltipTitleStyle = {
    marginBottom: 8,
    fontWeight: 700,
    fontSize: 17,
    color: '#222'
};

const SectionTitle = ({ title, isItalic = true, isBold = true, padding = '5px', paddingTop = '10px', paddingBottom = '0', textAlign = 'left', tooltipType }) => {
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    const tooltipContent = tooltipType ? TOOLTIP_TEXTS[tooltipType.toUpperCase()] : null;

    return (
        <>
            <CardTitle
                tag="h3"
                style={{
                    padding,
                    paddingTop,
                    paddingBottom,
                    textAlign,
                    fontStyle: isItalic ? 'italic' : 'normal',
                    fontWeight: isBold ? 'bold' : 'normal'
                }}
            >
                {title}
                {tooltipContent && (
                    <>
                        <i className="fas fa-info-circle ml-2" id={`${tooltipType}Tooltip`} style={{ cursor: 'pointer' }} />
                        <Tooltip placement="right" isOpen={tooltipOpen} target={`${tooltipType}Tooltip`} toggle={toggleTooltip} autohide={false}>
                            <div style={tooltipBoxStyle}>
                                <div style={tooltipTitleStyle}>{tooltipContent.title}</div>
                                <div style={{ fontWeight: 400, fontSize: 14, color: '#222' }}>{tooltipContent.description}</div>
                            </div>
                        </Tooltip>
                    </>
                )}
            </CardTitle>
        </>
    );
};

SectionTitle.propTypes = {
    title: PropTypes.string.isRequired,
    isItalic: PropTypes.bool,
    isBold: PropTypes.bool,
    padding: PropTypes.string,
    paddingTop: PropTypes.string,
    paddingBottom: PropTypes.string,
    textAlign: PropTypes.string,
    tooltipType: PropTypes.oneOf(['pickup', 'dropoff', 'details'])
};

export default SectionTitle;
